import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withAuth } from "../lib/AuthProvider";

function AdminRoute({ component: Component, isLoggedin, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedin ? (
          <Redirect to="/" />
        ) : user?.role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect to="/sales" />
        )
      }
    />
  );
}

export default withAuth(AdminRoute);
